import * as service from './calender.service'

export default {
  data() {
    return {
      events: [],
      config: {
        header: {
          right: ''
        },
        edit: false,
        editable: false,
        stick: true,
        defaultView: 'month'
      },
      eventDetails: [{
        'ActivityTypeDesc': '',
        'ProgramName': '',
        'Description': '',
        'StartDate': '',
        'EndDate': '',
        'MondayEnd': '',
        'MondayStart': '',
        'TuesdayEnd': '',
        'TuesdayStart': '',
        'WednesdayEnd': '',
        'WednesdayStart': '',
        'ThursdayEnd': '',
        'ThursdayStart': '',
        'FridayEnd': '',
        'FridayStart': '',
        'SaturdayEnd': '',
        'SaturdayStart': '',
        'SundayEnd': '',
        'SundayStart': '',

      }],
      Locations: [],
      Pools: [],
      locationId: '',
      locationName: '',
      poolId: '',

    }
  },

  mounted() {
    this.getLocations()
    let context = this

    this.$router.app.$on('emittedlocation_obj', (data) => {
      context.locationId = data.LocationId ? data.LocationId : ''
      context.locationName = data.LocationName ? ' - ' + data.LocationName : ''
      if (context.locationId) {
        context.GetActivityCalendar(this.locationId, this.poolId)
      }

      // alert(JSON.stringify(data))

    })
    this.$router.app.$on('emittedpool_obj', (data) => {

      context.poolId = data.PoolId ? data.PoolId : ''
      context.poolName = data.PoolName ? '(Aquatic Venue : ' + data.PoolName + ')' : ''
      if (context.poolId) {
        context.GetActivityCalendar(this.locationId, this.poolId)
      }


      // alert(JSON.stringify(data))

    })


    this.$router.app.$on('emitCalender', (data) => {

      context.getLocations()

    })

  },

  methods: {
    eventSelected(event) {

      this.eventDetails = []
      this.eventDetails.push(event.data)
      $('#eventsModel').modal('show')
    },
    getLocations() {
      let context = this

      service.GetLocations().then(function (response) {

        if (response) {
          if (response.length > 0) {
            context.Locations = response
            context.locationId = response[0].LocationId
            context.getpools(context.locationId)

          }

        }

      }, (error) => {

      })

    },
    locationChanged(locationId) {
      this.getpools(locationId)
    },
    getpools(locationid) {
      let context = this

      service.GetPools(locationid).then(function (response) {

        if (response) {

          if (response.length > 0) {
            context.Pools = response

            context.poolId = response[0].PoolId

            context.GetActivityCalendar(context.locationId, context.poolId)

          }
        }
      }, (error) => {

      })
    },
    poolChanged(poolId) {
      this.GetActivityCalendar(this.locationId, this.poolId)
    },
    GetActivityCalendar(locationid, poolId) {
      let context = this
      if (poolId) {
        service.GetActivityCalendar(locationid, poolId).then(function (response) {
          context.events = []
          if (response) {

            if (response.length > 0) {

              response.map(function (el) {

                context.events.push({
                  title: el.ProgramName,
                  start: context.$moment(el.StartDate).format('YYYY-MM-DD'),
                  end: context.$moment(el.EndDate).format('YYYY-MM-DD') + '' + 'T23:59:00',
                  data: el,
                  allDay: false
                })
              })

            }
          }
        }, (error) => {

        })
      }

    },

  }

}



// WEBPACK FOOTER //
// ./src/components/ActivityCalender/calender.controller.js